/**
 * Formats amount to have thousand comma separators, formats decimal value to 2 decimal places only
 * Returns human readable amount (1000 -> 1,000; 1000000.10 -> 1,000,000.10)
 */
export const formatAmount = (amount: string) => {
  // Remove non-digit and non-decimal characters
  const cleanedValue = amount.replace(/[^\d.]/g, '');

  // Split number into integer and decimal parts
  let [integerPart, decimalPart] = cleanedValue.split('.');

  // Add thousand separators to integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Limit decimal part to two digits
  decimalPart = decimalPart ? `.${decimalPart.slice(0, 2)}` : '';

  if (integerPart === '') {
    integerPart = '0';
  }

  // Combine integer and decimal parts
  return integerPart + decimalPart;
};

export const formatAmountOutput = (value: string) => {
  if (value === '') {
    return value;
  }

  if (value.indexOf('.') > -1) {
    return `${formatAmount(value)}`;
  } else {
    return `${formatAmount(value)}.00`;
  }
};
